import React from 'react';
import RichTextEditor from 'react-rte';


const styles = {
  toolbarStyle: {
    margin:0,
    paddingTop: 5,
    paddingLeft: 5,
    paddingBottom: 0,
    paddingRight: 0
  },
  editorStyle: {
    backgroundColor: '#F7F7F7',
    minHeight: 160
  },
};

export default class StatefulEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value ? RichTextEditor.createValueFromString(props.value, 'html') : RichTextEditor.createEmptyValue() };
  }

  onChange = (value) => {
    this.setState({value});
    if (this.props.onChange) {
      this.props.onChange(
        value.toString('html')
      );
    }
  };

  render () {
    return (
      <RichTextEditor
        editorStyle={styles.editorStyle}
        toolbarStyle={styles.toolbarStyle}
        value={this.state.value}
        onChange={this.onChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RichTextEditor.js